import React from 'react'
import MainLayouts from '../../layout/MainLayouts'
import AboutUsSection from './Components/AboutUsSection'
import CommunitySection from './Components/CommunitySection'
import JobSearchHero from './Components/JobSearchHero'
import InfoBlockSection from './Components/InfoBlockSection'
import VideoSection from './Components/VideoSection'
import TalentPlacement from './Components/TalentPlacement'
import TestimonialSection from './Components/TestimonialSection'
import NewsletterSubscription from '../LandingPage/Component/NewsletterSubscription'
import TrainingBanner from './Components/TrainingBanner'
const Opportunity = () => {
  
  return (
    <MainLayouts>
        <JobSearchHero/>
        <AboutUsSection />
        <CommunitySection />
        <InfoBlockSection />
        <VideoSection />
        <TestimonialSection/>
        <TalentPlacement/>     
        <TrainingBanner/>
        <NewsletterSubscription/>
        

    </MainLayouts>
  )
}

export default Opportunity